import styled from "styled-components";
import {
  subMenuDropdownBackground
} from '../../config/colors';

export const LiftingWrapper = styled.div`
  display: flex;
  flex-grow:1;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${subMenuDropdownBackground};
  padding: 40px 37px 80px 45px;

  @media print {
    padding: 20px 55px 20px 25px;
    background-color: inherit;

    img {
      width: 170px;
      height: 160px;
    }
    div {
      width: 170px !important;
      height: 160px !important;
    }
  }
`;

export const CharacteristicsWrapper = styled.ul`
    margin: 0;
    padding: 0;
    width: 47%;
    font-weight: 600;
    font-size: 0.875rem;

    @media print {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 61%;
    }
`;

export const CharacteristicsItemWrapper = styled.li`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 35px;

    @media print {
      width: 90%;
      margin-bottom: 15px;
    }
`;

export const CharacteristicsKey = styled.p`
  line-height: 150%;
  width: 48%;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
`;

export const CharacteristicsValueWrapper = styled.ul`
  margin: 0;
  padding: 0;
  width: 48%;
`;

export const CharacteristicsValue = styled.li`
  line-height: 150%;
  display: flex;
  justify-content: start;
`;

export const Divider = styled.hr`
  display: none;
  border: 1px solid black;
  width: 100%;
  @media print {
    display: block;
  }
`;
